import gql from 'graphql-tag';

export default fields => gql`
mutation ($externalId: String!, $providerId: String!) {
    deleteExternalMaps (input: { externalId: $externalId, providerId: $providerId }) {
        __typename
        #${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/ExternalMaps/DeleteMutation.js